import React from 'react';
import { EditTestConnectorApollo } from '@front-activerse/common-components';
import LabTestsEditContainer from './LabTestsEditContainer';
import { useLocation } from 'react-router-dom';

const TestsEditPage: React.FC = () => {
  const { measurement } = useLocation().state;

  return (
    <EditTestConnectorApollo>
      {({ editTest }) => (
        <LabTestsEditContainer
          key={measurement.id + measurement.type}
          editMeasurement={editTest.editMeasurement}
          measurement={measurement}
        />
      )}
    </EditTestConnectorApollo>
  );
};

export default TestsEditPage;
